import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class EditUserVm {
	userId: number;
	fullName?: string;
	email?: string;
	phoneNumber?: string;
	isActive: boolean;
	userName?: string;
	permissionId?: number;
	permission?: string;
	isLockedOut: boolean;
	inactivityTimeout: boolean;
	utilityProviderId?: number;
	utilityProviderName?: string;
	isAdmin: boolean;
	friendlyId?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'userId': new UntypedFormControl(0, [...(validators['userId'] ?? []), ...[Validators.required]]),
			'fullName': new UntypedFormControl(null, [...(validators['fullName'] ?? []), ...[Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern("^[a-zA-Z-']+( [a-zA-Z'-]+)*$")]]),
			'email': new UntypedFormControl(null, [...(validators['email'] ?? []), ...[Validators.required, Validators.email]]),
			'phoneNumber': new UntypedFormControl(null, [...(validators['phoneNumber'] ?? []), ...[Validators.required]]),
			'isActive': new UntypedFormControl(false, [...(validators['isActive'] ?? []), ...[]]),
			'userName': new UntypedFormControl(null, [...(validators['userName'] ?? []), ...[Validators.required, Validators.minLength(5), Validators.maxLength(256), Validators.pattern("^[A-Za-z0-9.@_'-]+$")]]),
			'permissionId': new UntypedFormControl(null, [...(validators['permissionId'] ?? []), ...[Validators.required]]),
			'permission': new UntypedFormControl(null, [...(validators['permission'] ?? []), ...[]]),
			'isLockedOut': new UntypedFormControl(false, [...(validators['isLockedOut'] ?? []), ...[]]),
			'inactivityTimeout': new UntypedFormControl(false, [...(validators['inactivityTimeout'] ?? []), ...[]]),
			'utilityProviderId': new UntypedFormControl(null, [...(validators['utilityProviderId'] ?? []), ...[]]),
			'utilityProviderName': new UntypedFormControl(null, [...(validators['utilityProviderName'] ?? []), ...[]]),
			'isAdmin': new UntypedFormControl(false, [...(validators['isAdmin'] ?? []), ...[]]),
			'friendlyId': new UntypedFormControl(null, [...(validators['friendlyId'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): EditUserVmFromFg {
		return new EditUserVmFromFg(fg);
	}
}

export class EditUserVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get userId(): number {
		return this.fg.get('userId').value;
	}
	set userId(val) {
		this.fg.get('userId').setValue(val);
	}

	get fullName(): string {
		return this.fg.get('fullName').value;
	}
	set fullName(val) {
		this.fg.get('fullName').setValue(val);
	}

	get email(): string {
		return this.fg.get('email').value;
	}
	set email(val) {
		this.fg.get('email').setValue(val);
	}

	get phoneNumber(): string {
		return this.fg.get('phoneNumber').value;
	}
	set phoneNumber(val) {
		this.fg.get('phoneNumber').setValue(val);
	}

	get isActive(): boolean {
		return this.fg.get('isActive').value;
	}
	set isActive(val) {
		this.fg.get('isActive').setValue(val);
	}

	get userName(): string {
		return this.fg.get('userName').value;
	}
	set userName(val) {
		this.fg.get('userName').setValue(val);
	}

	get permissionId(): number {
		return this.fg.get('permissionId').value;
	}
	set permissionId(val) {
		this.fg.get('permissionId').setValue(val);
	}

	get permission(): string {
		return this.fg.get('permission').value;
	}
	set permission(val) {
		this.fg.get('permission').setValue(val);
	}

	get isLockedOut(): boolean {
		return this.fg.get('isLockedOut').value;
	}
	set isLockedOut(val) {
		this.fg.get('isLockedOut').setValue(val);
	}

	get inactivityTimeout(): boolean {
		return this.fg.get('inactivityTimeout').value;
	}
	set inactivityTimeout(val) {
		this.fg.get('inactivityTimeout').setValue(val);
	}

	get utilityProviderId(): number {
		return this.fg.get('utilityProviderId').value;
	}
	set utilityProviderId(val) {
		this.fg.get('utilityProviderId').setValue(val);
	}

	get utilityProviderName(): string {
		return this.fg.get('utilityProviderName').value;
	}
	set utilityProviderName(val) {
		this.fg.get('utilityProviderName').setValue(val);
	}

	get isAdmin(): boolean {
		return this.fg.get('isAdmin').value;
	}
	set isAdmin(val) {
		this.fg.get('isAdmin').setValue(val);
	}

	get friendlyId(): string {
		return this.fg.get('friendlyId').value;
	}
	set friendlyId(val) {
		this.fg.get('friendlyId').setValue(val);
	}
}
